import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { baseGrid } from '@helpers/grid';
import { Device, from } from '@helpers/media';
import { m } from 'framer-motion';
import { rgba } from 'polished';
import styled from 'styled-components';
const Container = styled(m.div) `
  position: fixed;
  top: 0;
  left: 0;
  background-color: ${rgba(brand.black, 0.8)};
  width: 100%;
  height: 100%;
  display: block;
  z-index: 100;
`;
const CloseBtn = styled.button `
  position: absolute;
  top: 18px;
  right: 18px;
  background: transparent;
  border: none;
  display: flex;
  align-items: center;
  gap: 5px;
  flex-direction: column;
  color: ${brand.white};

  @media ${from(Device.Tablet)} {
    top: 0;
    left: calc(100% + 20px);
    right: auto;
  }

  span {
    font-size: ${fluid(8, 10)};
  }

  svg {
    width: ${fluid(16, 20)};
  }
`;
const VideoHolder = styled.div `
  ${baseGrid};
  height: 100%;
  padding: 8px;
`;
const VideoInner = styled.div `
  grid-column: span 24;
  align-self: center;
  justify-self: center;
  text-align: center;
  width: 100%;
  max-width: 900px;
`;
const VideoContainer = styled.figure `  

  @media ${from(Device.Tablet)} {
    position: relative;
  }
`;
const VideoWrapper = styled.div `
  aspect-ratio: 16 / 9;
`;
const Image = styled.img `
  width: 100%;
`;
const VideoModalStyles = {
    CloseBtn,
    Container,
    VideoContainer,
    VideoHolder,
    VideoInner,
    VideoWrapper,
    Image,
};
export default VideoModalStyles;
